import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'
import { ComponentLayouts } from '@cinch-nx/storyblok-utils'

const { HighlightsSection, ...slimComponents } = {
  ...landingStoryblokComponents,
}

export const brandPageStoryblokComponents: ComponentLayouts = {
  fullWidthWrapper: { HighlightsSection },
  slimWrapper: slimComponents,
}
